import React, { useState } from 'react';
import { Button } from './ui/button';
import { CheckCircle, Calendar, Mail, Phone, MapPin } from 'lucide-react';
import { ctaFinalData } from '../data/mock';

const Contact = () => {
  const openCalendly = () => {
    // Open Calendly in a popup window
    window.open(
      'https://calendly.com/esaezye',
      'calendly',
      'width=800,height=800,scrollbars=yes,resizable=yes'
    );
  };

  return (
    <section id="contacto" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* CTA Header */}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-[#013139] mb-4">
            {ctaFinalData.title}
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            {ctaFinalData.subtitle}
          </p>
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            {ctaFinalData.benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-2">
                <CheckCircle className="text-[#00E5A3]" size={20} />
                <span className="text-gray-700">{benefit}</span>
              </div>
            ))}
          </div>

          {/* Calendly CTA Button */}
          <Button
            onClick={openCalendly}
            size="lg"
            className="bg-[#00E5A3] hover:bg-[#00C497] text-[#013139] font-bold text-lg px-8 py-4"
          >
            <Calendar className="mr-2" size={24} />
            Reserva tu llamada gratuita ahora
          </Button>
        </div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
          {/* Calendly Embed */}
          <div className="bg-white p-4 rounded-2xl shadow-xl border border-gray-100 min-h-[700px]">
            <h3 className="text-2xl font-bold text-[#013139] mb-6 text-center">
              Selecciona tu horario preferido
            </h3>
            <div className="w-full h-[600px]">
              <iframe
                src="https://calendly.com/esaezye?hide_gdpr_banner=1&primary_color=00E5A3"
                width="100%"
                height="100%"
                frameBorder="0"
                title="Calendario de reservas"
                className="rounded-lg"
              />
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-[#013139] to-[#024F5B] p-8 rounded-2xl text-white">
              <h3 className="text-2xl font-bold mb-6">
                Información de contacto
              </h3>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00E5A3] rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="text-[#013139]" size={24} />
                  </div>
                  <div>
                    <div className="font-semibold mb-1">Email</div>
                    <a
                      href="mailto:esaezye@gmail.com"
                      className="text-gray-300 hover:text-[#00E5A3] transition-colors"
                    >
                      esaezye@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00E5A3] rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="text-[#013139]" size={24} />
                  </div>
                  <div>
                    <div className="font-semibold mb-1">Teléfono</div>
                    <p className="text-gray-300">
                      Disponible tras la primera llamada
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00E5A3] rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="text-[#013139]" size={24} />
                  </div>
                  <div>
                    <div className="font-semibold mb-1">Ubicación</div>
                    <p className="text-gray-300">
                      España (Consultoría online y presencial)
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Info Card */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <h4 className="text-xl font-bold text-[#013139] mb-4">
                ¿Por qué agendar una llamada?
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-[#00E5A3] flex-shrink-0 mt-0.5" size={20} />
                  <span className="text-gray-600">
                    Primera llamada gratuita sin compromiso
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-[#00E5A3] flex-shrink-0 mt-0.5" size={20} />
                  <span className="text-gray-600">
                    30 minutos de consultoría personalizada
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-[#00E5A3] flex-shrink-0 mt-0.5" size={20} />
                  <span className="text-gray-600">
                    Análisis inicial de tu situación
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-[#00E5A3] flex-shrink-0 mt-0.5" size={20} />
                  <span className="text-gray-600">
                    Presupuesto claro y sin sorpresas
                  </span>
                </li>
              </ul>
            </div>

            {/* Chatbot Alternative */}
            <div className="bg-gradient-to-r from-[#00E5A3]/10 to-[#013139]/10 p-6 rounded-2xl border border-gray-200">
              <h4 className="text-lg font-bold text-[#013139] mb-2">
                ¿Prefieres chatear primero?
              </h4>
              <p className="text-gray-600 text-sm">
                Usa nuestro chatbot en la esquina inferior derecha para resolver tus dudas de forma inmediata.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
